import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';

import ActivityEdit from './ActivityEdit';
import ActivityList from './ActivityList';

const ActivityPage = (props) => {
    let { path } = useRouteMatch();
    const [lastURLParams, setLastURLParams] = React.useState(new URLSearchParams(window.location.search));

    return (
        <Switch>
            <Route path={`${path}/:id/preview`}>
                <ActivityList setLastURLParams={setLastURLParams} {...props} />
            </Route>
            <Route path={`${path}/:id/:tab/:subtab`}>
                <ActivityEdit {...props} lastURLParams={lastURLParams} />
            </Route>
            <Route path={`${path}/:id/:tab`}>
                <ActivityEdit {...props} lastURLParams={lastURLParams} />
            </Route>
            <Route path={`${path}/:id`}>
                <ActivityEdit {...props} lastURLParams={lastURLParams} />
            </Route>
            <Route exact path={path}>
                <ActivityList setLastURLParams={setLastURLParams} {...props} />
            </Route>
        </Switch>
    );
};

export default ActivityPage;
